<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  data() {
    return {
      cdata: [
        { name: "山东", value: 1 },
        { name: "河北", value: 2 },
        { name: "吉林", value: 3 },
        { name: "黑龙江", value: 4 },
        { name: "辽宁", value: 5 },
        { name: "内蒙古", value: 6 },
        { name: "新疆", value: 7 },
        { name: "甘肃", value: 8 },
        { name: "宁夏", value: 9 },
        { name: "山西", value: 10 },
        { name: "陕西", value: 11 },
        { name: "河南", value: 12 },
        { name: "安徽", value: 13 },
        { name: "江苏", value: 14 },
        { name: "浙江", value: 15 },
        { name: "福建", value: 16 },
        { name: "广东", value: 17 },
        { name: "江西", value: 18 },
        { name: "海南", value: 19 },
        { name: "广西", value: 20 },
        { name: "贵州", value: 21 },
        { name: "湖南", value: 22 },
        { name: "湖北", value: 23 },
        { name: "四川", value: 24 },
        { name: "云南", value: 25 },
        { name: "西藏", value: 26 },
        { name: "青海", value: 27 },
        { name: "天津", value: 28 },
        { name: "上海", value: 29 },
        { name: "重庆", value: 30 },
        {
          name: "北京",
          value: 31,
          elseData: {
            // 这里放置地图 tooltip 里想显示的数据
          },
        },
        { name: "台湾", value: 32 },
        { name: "香港特别行政区", value: 33 },
        { name: "澳门特别行政区", value: 34 },
      ],
    };
  },
  components: {
    Chart,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
